exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".setting-fab{top:50%!important;right:0;border-radius:0}.page-wrapper{min-height:calc(100vh - 64px - 50px - 81px)}.page-enter-active,.page-leave-active{transition:opacity .2s,transform .2s}.page-enter{opacity:0;transform:translateX(-30%)}.page-leave-to{opacity:0;transform:translateX(30%)}.fade-enter-active,.fade-leave-active{transition-duration:.5s;transition-property:opacity;transition-timing-function:ease}.fade-enter,.fade-leave-active{opacity:0}", ""]);

// exports
